<section class="section-sp" id="section-similar-patients">

  <div class='container-paralellplot' id='container-paralellplot'></div>

  <!-- @todo enable split view by the future design -->
  <!--
  <div id="div-charts-separator">
    <hr id="horizontal-charts-separator" class="hr-sep-sp"/>
    <em id="charts-separator-down" class="icon__ArrowDown charts-separator-icon"></em>
    <em id="charts-separator-up" class="icon__ArrowUp charts-separator-icon"></em>
  </div>
  -->

  <div id="div-charts">
    <analytics-charts
      [chartDataFeeder]="getChartsDataSource()">
    </analytics-charts>
  </div>

</section>

